<template>
    <div class="department">
        <Head-view :showStyle="-2"></Head-view>
        <div class="main">
            <div class="breadcrumb">修改密码</div>

            <div class="showTba">
                <div class="fromBox">
                    <div class="fromTitle">旧密码</div>
                    <div class="fromInp">
                        <el-input
                            type="text"
                            v-model="oldPassword"
                            placeholder="请输入"
                            @blur="trimBoth(oldPassword, 'oldPassword')"
                        ></el-input>
                    </div>
                </div>
                <div class="fromBox">
                    <div class="fromTitle">新密码</div>
                    <div class="fromInp">
                        <el-input
                            type="text"
                            v-model="newPassword"
                            placeholder="请输入"
                            @blur="trimBoth(newPassword, 'newPassword')"
                        ></el-input>
                    </div>
                </div>
                <div class="fromBox">
                    <div class="fromTitle">重复输入新密码</div>
                    <div class="fromInp">
                        <el-input
                            type="text"
                            v-model="newsPassword"
                            placeholder="请输入"
                            @blur="trimBoth(newsPassword, 'newsPassword')"
                        ></el-input>
                    </div>
                </div>

                <div class="fromBox submit">
                    <div class="submitBtn" @click="submit()">
                        确定
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "department",
    data() {
        return {
            userNumber: '',
            oldPassword: "",
            newPassword: "",
            newsPassword: "",
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        this.userNumber = localStorage.getItem('staffNumber')
    },

    methods: {
        submit() {
            if (!this.oldPassword) {
                this.$message({
                    type: 'warning',
                    message: '请输入旧密码'
                })
            } else if (!this.newPassword) {
                this.$message({
                    type: 'warning',
                    message: '请输入新密码'
                })
            } else if (!this.newsPassword) {
                this.$message({
                    type: 'warning',
                    message: '请输入再次新密码'
                })
            } else if (this.newPassword != this.newsPassword) {
                this.$confirm('两次输入的新密码不一致', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '',
                    type: 'warning'
                }).then(() => {}).catch(() => {})
            }
            let data = {
                username: this.userNumber,
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
            }
            this.request.post(this.baseUrl + 'account/resetPasswordByAccount', data)
                .then(res => {
                    if (res.code == 0 && res.data.result) {
                        this.$message({
                            type: 'success',
                            message: '密码修改成功'
                        })
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                }).catch(err => {
                    this.$message({
                            type: 'error',
                            message: '修改失败，请稍后重试'
                        })
                })


        },

        trimBoth(val, key) {

            let trimStr = val.replace(/\s*/g, '')
            switch (key) {
                case 'oldPassword':
                    this.oldPassword = trimStr
                    break;
                case 'newPassword': 
                    this.newPassword = trimStr
                    break;
                case 'newsPassword': 
                    this.newsPassword = trimStr
                    break;
            }
        }
    },
};
</script>

<style lang="less" scoped>
.department {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 24px 17px 0 24px;
            height: 692px;
            background: #fff;

            .fromBox {
                margin-bottom: 30px;
                display: flex;
                flex-direction: row;
                height: 40px;
                line-height: 40px;
                .fromTitle {
                    width: 107px;
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(84, 85, 86, 1);
                    text-align: left;
                }

                .fromInp {
                    width: 265px;

                    /deep/ .el_input_inner {
                        width: 100%;
                    }
                }
            }

            .submit {
                display: block;
                padding-top: 10px;
                width: 372px;

                .submitBtn {
                    float: right;
                    width: 68px;
                    height: 40px;
                    border-radius: 4px;
                    background: rgba(4, 134, 254, 1);
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(255, 255, 255, 1);
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>